import React, { useEffect, useState } from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import ButtonPrimary from "../buttons/ButtonPrimary";
import "./CreateClubFundraiser.css";
import { useNavigate, useParams } from "react-router-dom";
import ProfileAccount from "../account/ProfileAccount";
import axios from "axios";
import useLoading from "../../hooks/UseLoading";
import useAlert from "../../hooks/UseAlert";
import SuccesNotification from "../../hooks/SuccesNotification";

// ── Benefit icons (inline SVG, outline style matching approved design) ─────────
const IconClipboard = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="9" y="7" width="18" height="22" rx="2" stroke="#2d7a3a" strokeWidth="2"/>
    <path d="M14 7V5a2 2 0 014 0v2" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M13 18l3 3 7-7" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const IconTag = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8h9l11 11-9 9L8 17V8z" stroke="#2d7a3a" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="13" cy="13" r="2" fill="#2d7a3a"/>
  </svg>
);
const IconTrophy = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6h12v10a6 6 0 01-12 0V6z" stroke="#2d7a3a" strokeWidth="2"/>
    <path d="M12 10H8a4 4 0 004 4" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 10h4a4 4 0 01-4 4" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M18 22v5M13 27h10" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconPeople = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13" cy="13" r="4" stroke="#2d7a3a" strokeWidth="2"/>
    <circle cx="23" cy="13" r="4" stroke="#2d7a3a" strokeWidth="2"/>
    <path d="M5 28c0-5 3.6-8 8-8" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M31 28c0-5-3.6-8-8-8" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 28c0-4 2.7-6 6-6s6 2 6 6" stroke="#2d7a3a" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconShirt = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 6l-7 5 4 2v15h16V13l4-2-7-5c0 2-2 4-5 4s-5-2-5-4z" stroke="#2d7a3a" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

const BENEFITS = [
  {
    Icon: IconClipboard,
    title: "One-time registration",
    desc: "Quick and easy setup. Once you're in, you're ready to go.",
  },
  {
    Icon: IconTag,
    title: "No upfront costs to your club",
    desc: "It's free to register. You keep more of what you raise.",
  },
  {
    Icon: IconTrophy,
    title: "Fun, engaging and skill-based competitions",
    desc: "Supporters enjoy predicting matches across the sports they love.",
  },
  {
    Icon: IconPeople,
    title: "Engage members, supporters and local communities",
    desc: "Bring your club and community together around shared passion.",
  },
  {
    Icon: IconShirt,
    title: "Suitable for men's and women's sports",
    desc: "Create competitions for any team, any league, any time.",
  },
];

// ── Promo card illustration ────────────────────────────────────────────────────
const PromoIllustration = () => (
  <svg viewBox="0 0 200 140" xmlns="http://www.w3.org/2000/svg" fill="none" className="cf_promo_svg">
    {/* Sparkles */}
    <path d="M22 38l3-7 3 7 7 3-7 3-3 7-3-7-7-3z" fill="rgba(245,166,35,0.7)"/>
    <path d="M168 28l2-5 2 5 5 2-5 2-2 5-2-5-5-2z" fill="rgba(245,166,35,0.7)"/>
    <path d="M158 98l2-4 2 4 4 2-4 2-2 4-2-4-4-2z" fill="rgba(245,166,35,0.5)"/>
    <path d="M30 90l1.5-3.5 1.5 3.5 3.5 1.5-3.5 1.5-1.5 3.5-1.5-3.5-3.5-1.5z" fill="rgba(255,255,255,0.4)"/>
    {/* Flag pole */}
    <line x1="100" y1="12" x2="100" y2="82" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    {/* Flag / shield */}
    <path d="M100 12 L134 12 L134 40 L117 50 L100 40 Z" fill="rgba(245,166,35,0.85)" stroke="rgba(245,166,35,1)" strokeWidth="1.5" strokeLinejoin="round"/>
    {/* Star in shield */}
    <path d="M117 20l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6z" fill="white"/>
    {/* Left figure */}
    <circle cx="60" cy="60" r="9" stroke="white" strokeWidth="2"/>
    <path d="M51 73 Q60 83 69 73 L71 108 L49 108 Z" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.12)" strokeLinejoin="round"/>
    <line x1="51" y1="79" x2="43" y2="92" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <line x1="69" y1="79" x2="77" y2="92" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    {/* Centre figure */}
    <circle cx="100" cy="58" r="11" stroke="white" strokeWidth="2"/>
    <path d="M89 73 Q100 85 111 73 L113 108 L87 108 Z" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.12)" strokeLinejoin="round"/>
    <line x1="100" y1="69" x2="100" y2="82" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="89" y1="79" x2="81" y2="92" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    {/* Right figure */}
    <circle cx="140" cy="60" r="9" stroke="white" strokeWidth="2"/>
    <path d="M131 73 Q140 83 149 73 L151 108 L129 108 Z" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.12)" strokeLinejoin="round"/>
    <line x1="131" y1="79" x2="123" y2="92" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <line x1="149" y1="79" x2="157" y2="92" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const getTenantCurrency = () => {
  if (typeof window !== "undefined" && (window.location.hostname.toLowerCase().endsWith(".com.au") || window.location.hostname === "localhost")) {
    return "AUD";
  }

  return "EUR";
};

const getCurrencySymbol = (currencyCode) => {
  const symbols = {
    AUD: "$",
    CAD: "$",
    EUR: "€",
  };

  return symbols[currencyCode] || currencyCode;
};

export default function CreateClubFundraiser() {
  var url = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  var session_key = localStorage.getItem("session_key");
  const { sportId, leagueId } = useParams();
  const [loader, showLoader, hideLoader] = useLoading();
  const [leagues, setLeagues] = useState([]);
  const [sports, setSports] = useState([]);
  const [alert, alert_notify] = useAlert();
  const [loading, setLoading] = useState(true);

  const [successStatus, setSuccesStatus] = useState(false);
  const [validSport, setValidSport] = useState(false);
  const [validLeague, setValidLeague] = useState(false);
  const [validOrgName, setValidOrgName] = useState(false);
  const [validEntryFee, setValidEntryFee] = useState(false);
  const [validAccountName, setValidAccountName] = useState(false);
  const [validSortCode, setValidSortCode] = useState(false);
  const [validAccNumb, setValidAccNumb] = useState(false);
  const [validCompTitle, setValidCompTitle] = useState(false);
  const [currency, setCurrency] = useState(getTenantCurrency)
  const [cfLabels, setCfLabels] = useState([])
  const [accordion1Open, setAccordion1Open] = useState(false)
  const [accordion2Open, setAccordion2Open] = useState(false)
  const [accordion3Open, setAccordion3Open] = useState(false)
  const [accordion4Open, setAccordion4Open] = useState(false)
  const [benefitsOpen, setBenefitsOpen] = useState(false)
  const [showOtherPurpose, setShowOtherPurpose] = useState(false)
  const [otherPurposeValue, setOtherPurposeValue] = useState('')
  const [authorisedConfirmed, setAuthorisedConfirmed] = useState(false)

  // Club Registration Form state
  const [showRegForm, setShowRegForm] = useState(false)
  const [regSuccess, setRegSuccess] = useState(false)
  const [regId, setRegId] = useState('')
  const [regClubName, setRegClubName] = useState('')
  const [regFirstName, setRegFirstName] = useState('')
  const [regLastName, setRegLastName] = useState('')
  const [regUsername, setRegUsername] = useState('')
  const [regEmail, setRegEmail] = useState('')
  const [regIban, setRegIban] = useState('')
  const [regSecondaryEmail, setRegSecondaryEmail] = useState('')
  const [regMembership, setRegMembership] = useState('')
  const [regWebsite, setRegWebsite] = useState('')
  const [regAuthorised, setRegAuthorised] = useState(false)

  const [entryFee, setEntryFee] = useState(1);
  const [entrants, setEntrants] = useState(2);
  const [sportsFirst, setSportsFirst] = useState(50);
  const [sportsSecond, setSportsSecond] = useState(25);
  const [sportsThird, setSportsThird] = useState(15);
  const [sportsClub, setSportsClub] = useState(10);
  const currencySymbol = getCurrencySymbol(currency);

  const getClubFundraiserData = () => {
    var create_club_fundraiser_sports = document.getElementById("create_club_fundraiser_sports").value;
    var create_club_fundraiser_leagues = document.getElementById("create_club_fundraiser_leagues").value;
    var organisation_name_valid = document.getElementById("organisation_name").value;
    var account_name_valid = document.getElementById("account_name").value;
    var sort_code_valid = document.getElementById("sort_code").value;
    var account_number_valid = document.getElementById("account_number").value;
    var create_club_fundraiser_entry_fee = document.getElementById("create_club_fundraiser_entry_fee").value;
    var competition_title_valid = document.getElementById("competition_title").value;

    if (organisation_name_valid !== "") { setValidOrgName(true); } else { setValidOrgName(false); }
    if (account_name_valid !== "") { setValidAccountName(true); } else { setValidAccountName(false); }
    if (sort_code_valid !== "") { setValidSortCode(true); } else { setValidSortCode(false); }
    if (account_number_valid !== "") { setValidAccNumb(true); } else { setValidAccNumb(false); }
    if (competition_title_valid !== "") { setValidCompTitle(true); } else { setValidCompTitle(false); }
    if (create_club_fundraiser_sports !== "0") { setValidSport(true); } else { setValidSport(false); }
    if (create_club_fundraiser_leagues !== "0") { setValidLeague(true); } else { setValidLeague(false); }
    if (create_club_fundraiser_entry_fee !== "0") { setValidEntryFee(true); } else { setValidEntryFee(false); }
  };

  const calculateMaxPayout = (percentage) => {
    return (((entryFee * entrants) / 100) * percentage).toFixed(2);
  }

  const submitCreateClubFundraiser = (e) => {
    e.preventDefault();
    var create_club_fundraiser_url = "" + url + "/api/create_contest/request_contest";

    var organisation_name = document.getElementById("organisation_name").value;
    var account_name = document.getElementById("account_name").value;
    var sort_code = document.getElementById("sort_code").value;
    var account_number = document.getElementById("account_number").value;
    var competition_title = document.getElementById("competition_title").value;
    var create_club_fundraiser_sports = document.getElementById("create_club_fundraiser_sports").value;
    var create_club_fundraiser_leagues = document.getElementById("create_club_fundraiser_leagues").value;
    var create_club_fundraiser_entry_fee = document.getElementById("create_club_fundraiser_entry_fee").value;
    var create_club_fundraiser_entrants = document.getElementById("create_club_fundraiser_entrants").value;
    var create_club_fundraiser_sports_first = document.getElementById("create_club_fundraiser_sports_first").value;
    var create_club_fundraiser_sports_second = document.getElementById("create_club_fundraiser_sports_second").value;
    var create_club_fundraiser_sports_third = document.getElementById("create_club_fundraiser_sports_third").value;
    var create_club_fundraiser_club = document.getElementById("create_club_fundraiser_club").value;

    if (create_club_fundraiser_entry_fee === "") { create_club_fundraiser_entry_fee = 1; }
    if (create_club_fundraiser_entrants === "") { create_club_fundraiser_entrants = 2; }
    if (create_club_fundraiser_sports_first === "") { create_club_fundraiser_sports_first = 0.5; }
    if (create_club_fundraiser_sports_second === "") { create_club_fundraiser_sports_second = 0.25; }
    if (create_club_fundraiser_sports_third === "") { create_club_fundraiser_sports_third = 0.15; }
    if (create_club_fundraiser_club === "") { create_club_fundraiser_club = 0.10; }

    if (Number(sportsFirst) + Number(sportsSecond) + Number(sportsThird) + Number(sportsClub) !== 100) {
      alert_notify("error", "Payouts must equal 100%");
      return false;
    }

    var league_el = document.getElementById("create_club_fundraiser_leagues");
    var sport_el = document.getElementById("create_club_fundraiser_sports");
    create_club_fundraiser_leagues = league_el.options[league_el.selectedIndex].getAttribute("data-id");
    create_club_fundraiser_sports = sport_el.options[league_el.selectedIndex].getAttribute("data-id");

    if (!authorisedConfirmed) {
      alert_notify("error", "Please confirm you are authorised to register this club.");
      return false;
    }
    if (validOrgName && validAccountName && validSortCode && validAccNumb && validCompTitle && validSport && validLeague && validEntryFee) {
      var body = {
        organisation_name: organisation_name,
        bankaccount_name: account_name,
        bankaccount_number: sort_code,
        bankaccount_sortcode: account_number,
        competition_title: competition_title,
        contest_type: "club",
        league_id: create_club_fundraiser_leagues,
        entry_fee: create_club_fundraiser_entry_fee,
        num_of_entrants: create_club_fundraiser_entrants,
        payout_1st: create_club_fundraiser_sports_first,
        payout_2nd: create_club_fundraiser_sports_second,
        payout_3rd: create_club_fundraiser_sports_third,
        payout_club: create_club_fundraiser_club,
        sport_id: create_club_fundraiser_sports,
        currency: currency
      };
      var headers = { session_key: session_key };
      showLoader();
      axios.post(create_club_fundraiser_url, body, { headers })
        .then((response) => {
          if (response.status === 200) {
            setSuccesStatus(true);
            alert_notify("success", "Club Fundraiser request has been made successfully.");
          }
          hideLoader();
        })
        .catch((err) => {
          if (err.response.status === 401) {
            navigate("/login");
            localStorage.removeItem("session_key");
          } else {
            alert_notify("error", err.response.data.Message);
          }
          hideLoader();
        });
    } else {
      alert_notify("error", "All fields required !");
    }
  };

  const handleSportChange = () => {
    var leagues_html = `<option value="0">League</option>`;
    var sport_id = document.getElementById("create_club_fundraiser_sports").value;
    var sport_leagues = leagues.filter((row) => { return row.sport_id === sport_id; });
    sport_leagues.map((league, index) => {
      return (leagues_html += `<option data-id="${league.league_id}" value="${league.league_id}" key="${index}">${league.league_name}</option>`);
    });
    document.getElementById("create_club_fundraiser_leagues").innerHTML = leagues_html;
  };

  const clubFundraiserLabels = () => {
    var cf_labels_url = "" + url + "/static_content/get_all_labels";
    var body = { "page_name": "create club fundraiser" };
    showLoader();
    axios.post(cf_labels_url, body)
      .then((response) => {
        if (response.status === 200) { setCfLabels(response.data.Data.content); }
        hideLoader();
      })
      .catch((err) => { console.log(err); hideLoader(); });
  }

  useEffect(() => {
    clubFundraiserLabels();
    var session_key = localStorage.getItem("session_key");
    var view_all_sport_url = `${url}/api/common/sidebar`;
    const body = {};
    const headers = { session_key: session_key };
    showLoader();
    axios.get(view_all_sport_url, body, { headers })
      .then((response) => {
        if (response.status === 200) {
          var data = response.data.Data;
          data.sort((a, b) => (a.sport_name > b.sport_name ? 1 : -1));
          setSports(data);
          var leagues_array = [];
          for (var i = 0; i < data.length; i++) {
            var row = data[i];
            var states = row.leagues;
            if (states != null) {
              for (const property in states) {
                for (var k = 0; k < states[property].length; k++) {
                  leagues_array.push(states[property][k]);
                  setLeagues(leagues_array);
                  setLoading(false);
                }
              }
            }
          }
        }
        hideLoader();
      })
      .catch((err) => {
        hideLoader();
        console.log(err);
        navigate("/login");
        localStorage.removeItem("session_key");
      });
    setSuccesStatus(false);
  }, [leagueId]);

  const handleCurrencyChange = (e) => {
    var currency = e.target.value;
    setCurrency(currency);
  }

  const handlePurposeChange = (e) => {
    setShowOtherPurpose(e.target.value === 'Other');
    if (e.target.value !== 'Other') setOtherPurposeValue('');
  }

  const PERSONAL_DOMAINS = ['gmail.com','googlemail.com','yahoo.com','yahoo.co.uk','yahoo.ie','hotmail.com','hotmail.co.uk','hotmail.ie','outlook.com','outlook.ie','live.com','live.co.uk','live.ie','icloud.com','me.com','mac.com','aol.com','protonmail.com','proton.me']
  const isPersonalEmail = (email) => { const d = email.split('@')[1]?.toLowerCase(); return !!d && PERSONAL_DOMAINS.includes(d) }

  const submitClubRegistration = (e) => {
    e.preventDefault()
    if (!regClubName.trim() || !regFirstName.trim() || !regLastName.trim() || !regUsername.trim() || !regEmail.trim() || !regIban.trim()) {
      alert_notify('error', 'Please complete all mandatory fields.')
      return
    }
    if (isPersonalEmail(regEmail) && !regSecondaryEmail.trim()) {
      alert_notify('error', 'A secondary club email is required when using a personal email address (Gmail, Outlook, etc.).')
      return
    }
    if (!regAuthorised) {
      alert_notify('error', 'Please confirm you are authorised to register this club.')
      return
    }
    const reg_url = `${url}/api/create_contest/register_clubfundraiser`
    const sk = localStorage.getItem("session_key");
    const body = {
      organisation_name: regClubName.trim(),
      first_name: regFirstName.trim(),
      last_name: regLastName.trim(),
      username: regUsername.trim(),
      email: regEmail.trim(),
      club_iban: regIban.trim(),
      secondary_email: regSecondaryEmail.trim(),
      membership_size: regMembership || null,
      club_website: regWebsite.trim(),
      authorised_confirmed: 1,
      session_key: sk,
    }
    showLoader()
    axios.post(reg_url, body, { headers: { Authorization: sk, session_key: sk } })
      .then((res) => {
        const id = res.data?.Data?.registration_id || res.data?.data?.registration_id || ''
        setRegId(id)
        setRegSuccess(true)
        setShowRegForm(false)
        hideLoader()
      })
      .catch((err) => {
        alert_notify('error', err.response?.data?.Message || 'Registration failed. Please try again.')
        hideLoader()
      })
  }

  return (
    <React.Fragment>
      <Header />
      <ProfileAccount headerValue={
        !cfLabels.create_club_fundraiser_page_label ? 'CREATE CLUB FUNDRAISER' : cfLabels.create_club_fundraiser_page_label.label_name
      } />
      <div className="create_club_fundraiser_container">
        {successStatus ? (
          <SuccesNotification content="Club Fundraising sign up has been sent successfully." />
        ) : (
          <div className="page_content_center">

            {/* ── NEW: Benefits hero (approved design) ───────────────────────── */}
            <div className="cf_benefits_hero">
              <button className="cf_accordion_header cf_hero_toggle" type="button" onClick={() => setBenefitsOpen(!benefitsOpen)}>Why Club Fundraising? <span>{benefitsOpen ? '\u25B2' : '\u25BC'}</span></button>

              {benefitsOpen && (
              <div className="cf_hero_body">
                {/* Left — benefits list */}
                <div className="cf_hero_left">
                  {BENEFITS.map(({ Icon, title, desc }, i) => (
                    <div className="cf_benefit_row" key={i}>
                      <div className="cf_benefit_icon"><Icon /></div>
                      <div className="cf_benefit_text">
                        <strong>{title}</strong>
                        <p>{desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Right — promo card */}
                <div className="cf_hero_right">
                  <div className="cf_promo_card">
                    <PromoIllustration />
                    <div className="cf_promo_tagline_block">
                      <p>Raise more.</p>
                      <p>Engage more.</p>
                      <p className="cf_promo_grow">Grow your club.</p>
                    </div>
                    <div className="cf_promo_divider_line"></div>
                    <p className="cf_promo_sub">Start the supporters<br />banter now.</p>
                  </div>
                </div>
              </div>

              )}
              {/* CTA / form states */}
              {!regSuccess && !showRegForm && (
                <div className="cf_cta_section">
                  <button
                    className="cf_cta_btn"
                    type="button"
                    onClick={() => setShowRegForm(true)}
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{flexShrink:0}}>
                      <path d="M3 14l4-5 3 3 3-4 4 6H3z" fill="white"/>
                      <rect x="2" y="15" width="16" height="2" rx="1" fill="white"/>
                    </svg>
                    Get started now
                  </button>
                  <div className="cf_trust_row">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 1L2 3v4c0 3 2.3 5.6 5 6.4C9.7 12.6 12 10 12 7V3L7 1z" stroke="#2d7a3a" strokeWidth="1.4" fill="none"/>
                      <path d="M4.5 7l2 2 3-3" stroke="#2d7a3a" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Free to register</span>
                    <span className="cf_trust_dot">•</span>
                    <span>No obligations</span>
                    <span className="cf_trust_dot">•</span>
                    <span>Cancel anytime</span>
                  </div>
                </div>
              )}

              {regSuccess && (
                <div className="cf_reg_success">
                  <div className="cf_reg_success_icon">&#10003;</div>
                  <h3 className="cf_reg_success_title">Registration Submitted Successfully</h3>
                  <p className="cf_reg_success_text">Your Club Registration ID is:</p>
                  <div className="cf_reg_success_id">{regId}</div>
                  <p className="cf_reg_success_text">A confirmation email has been sent to your registered email address. Our team will review your application and be in touch within 2 business days.</p>
                  <p className="cf_reg_success_support">Questions? <a href="mailto:clubs@toppredictor.com" className="cf_support_link">clubs@toppredictor.com</a></p>
                </div>
              )}

              {showRegForm && (
                <div className="cf_reg_form_container">
                  <h3 className="cf_reg_form_title">Club Fundraiser Registration</h3>
                  <form onSubmit={submitClubRegistration} noValidate>
                    <p className="cf_reg_section_label">Club Details</p>
                    <div className="cf_reg_field">
                      <input type="text" className="cf_reg_input" placeholder="Club Name *" value={regClubName} onChange={(e) => setRegClubName(e.target.value)} maxLength="100" />
                    </div>
                    <div className="cf_reg_field">
                      <input type="text" className="cf_reg_input" placeholder="Club IBAN *" value={regIban} onChange={(e) => setRegIban(e.target.value)} maxLength="34" />
                    </div>
                    <div className="cf_reg_field">
                      <input type="number" className="cf_reg_input" placeholder="Membership Size (optional)" value={regMembership} onChange={(e) => setRegMembership(e.target.value)} min="1" />
                    </div>
                    <div className="cf_reg_field">
                      <input type="text" className="cf_reg_input" placeholder="Club Website / Social Media Link (optional)" value={regWebsite} onChange={(e) => setRegWebsite(e.target.value)} maxLength="300" />
                    </div>
                    <p className="cf_reg_section_label">Primary Contact</p>
                    <div className="cf_reg_field cf_reg_field_row">
                      <input type="text" className="cf_reg_input" placeholder="First Name *" value={regFirstName} onChange={(e) => setRegFirstName(e.target.value)} maxLength="50" />
                      <input type="text" className="cf_reg_input" placeholder="Last Name *" value={regLastName} onChange={(e) => setRegLastName(e.target.value)} maxLength="50" />
                    </div>
                    <div className="cf_reg_field">
                      <input type="text" className="cf_reg_input" placeholder="Username *" value={regUsername} onChange={(e) => setRegUsername(e.target.value)} maxLength="50" />
                    </div>
                    <div className="cf_reg_field">
                      <input type="email" className="cf_reg_input" placeholder="Primary Contact Email *" value={regEmail} onChange={(e) => setRegEmail(e.target.value)} maxLength="100" />
                      {isPersonalEmail(regEmail) && (
                        <p className="cf_reg_hint">Personal email detected — a secondary club email address is required.</p>
                      )}
                    </div>
                    {isPersonalEmail(regEmail) && (
                      <div className="cf_reg_field">
                        <input type="email" className="cf_reg_input cf_reg_input_highlight" placeholder="Secondary Club Email Address *" value={regSecondaryEmail} onChange={(e) => setRegSecondaryEmail(e.target.value)} maxLength="100" />
                      </div>
                    )}
                    <div className="cf_reg_field cf_reg_authorise_field">
                      <label className="cf_authorise_label">
                        <input type="checkbox" className="cf_authorise_checkbox" checked={regAuthorised} onChange={(e) => setRegAuthorised(e.target.checked)} />
                        <span>I confirm I am authorised to register this club and provide the club bank details for fundraising payments.</span>
                      </label>
                    </div>
                    <div className="cf_reg_actions">
                      <button type="submit" className="btn_cf_submit_reg">SUBMIT REGISTRATION</button>
                      <button type="button" className="btn_cf_cancel_reg" onClick={() => setShowRegForm(false)}>Cancel</button>
                    </div>
                  </form>
                  <p className="cf_reg_support">Need help? <a href="mailto:clubs@toppredictor.com" className="cf_support_link">clubs@toppredictor.com</a></p>
                </div>
              )}

              {/* How Club Fundraising Works */}
              <div className="cf_accordion cf_accordion_tight cf_accordion_how">
                <button className="cf_accordion_header" type="button" onClick={() => setAccordion2Open(!accordion2Open)}>
                  <span>How Club Fundraising Works</span>
                  <span className="cf_accordion_icon">{accordion2Open ? '▲' : '▼'}</span>
                </button>
                {accordion2Open && (
                  <div className="cf_accordion_content">
                    <p className="cf_accordion_subtitle"><strong>Create. Share. Engage. Raise Funds.</strong></p>
                    <div className="cf_steps">
                      <div className="cf_step"><span className="cf_step_num">1.</span><div><strong>Create a Competition</strong><p>Choose your sport, tournament and fundraising allocation.</p></div></div>
                      <div className="cf_step"><span className="cf_step_num">2.</span><div><strong>Share Your Competition</strong><p>Share your competition link with members, supporters, family and friends.</p><p>Once shared, participants register, enter and compete directly through Top Predictor.</p></div></div>
                      <div className="cf_step"><span className="cf_step_num">3.</span><div><strong>Engage Your Community</strong><p>Participants predict results, compete for prizes and enjoy friendly rivalry and club banter.</p></div></div>
                      <div className="cf_step"><span className="cf_step_num">4.</span><div><strong>Raise Funds</strong><p>Prize winners are settled automatically and your club receives its fundraising allocation.</p><p>No manual administration is required after your competition is launched.</p></div></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* ── END benefits hero ────────────────────────────────────────────── */}

            <div className="row m-0" style={{display:'none'}}>
              <div className="col-12">
                <span className="club_fundraiser_details">
                  A one-off refundable deposit of <span className="fundraiser_currency_sign">{currencySymbol}</span>5.00 will need to be made to:<br />
                </span>
                <br />
                <span className="club_fundraiser_details">
                  {!cfLabels.create_club_fundraiser_account_name ? 'Account Name' : cfLabels.create_club_fundraiser_account_name.label_name}:{" "}
                  <span className="club_fundraiser_bold">TPG Technology NZ Limited</span>{" "}
                  <br />{!cfLabels.create_club_fundraiser_account_number ? 'Account Number' : cfLabels.create_club_fundraiser_account_number.label_name}:{" "}
                  <span className="club_fundraiser_bold">12-3148-0156793-00</span>{" "}<br />
                </span>
                <br />
                <span className="club_fundraiser_details">Once we have verified your account we will set-up the competition.<br /></span>
                <div className="mobile_club_fundraiser_details">
                  <span className="club_fundraiser_details">
                    Please be aware that we can only accept payments from{" "}
                    <span className="club_fundraiser_bold ">New Zealand</span>{" "}accounts at this time.
                  </span>
                </div>
              </div>
            </div>

            <form id="form_club_fundraiser" onSubmit={submitCreateClubFundraiser}>
              <div className="club_fundraiser_selections">
                <div className="club_fundraiser_select_options_tittle col-12">
                  <span className="club_fundraiser_details">Please select one option only from each of the following:</span>
                </div>
                <div className="row mt-row">
                  <div className="col-12 col-xl-6 col-lg-5 cf_form_column">
                    <div className="col-12 mt-4">
                      <input
                        type="text"
                        id="organisation_name"
                        className="organization_name_input"
                        maxLength="50"
                        placeholder={!cfLabels.create_club_fundraiser_organisation_name ? 'Organisation Name' : cfLabels.create_club_fundraiser_organisation_name.label_name}
                      />
                    </div>
                    <div className="col-12 mt-4">
                      <input
                        type="text"
                        id="competition_title"
                        className="competition_title_input"
                        maxLength="50"
                        placeholder={!cfLabels.create_club_fundraiser_competition_title ? 'Competition Title' : cfLabels.create_club_fundraiser_competition_title.label_name}
                      />
                    </div>
                    <div className="col-12 mt-4">
                      <select className="create_club_fundraiser_select" id="create_club_fundraiser_sports" onChange={handleSportChange}>
                        <option value="0">{!cfLabels.create_club_fundraiser_sport ? 'Sport' : cfLabels.create_club_fundraiser_sport.label_name}</option>
                        {sports.map((sport, index) => {
                          var selected = sport.sport_id == sportId ? true : false;
                          if (sport.leagues) {
                            return (<option data-id={sport.sport_id} key={index} value={sport.sport_id} selected={selected}>{sport.sport_name}</option>);
                          }
                        })}
                      </select>
                    </div>
                    <div className="col-12 mt-4" style={{display:'none'}}>
                      <select className="create_club_fundraiser_select" id="create_club_fundraiser_leagues">
                        <option value="0">{!cfLabels.create_club_fundraiser_league ? 'League' : cfLabels.create_club_fundraiser_league.label_name}</option>
                        {leagues.map((league, index) => {
                          if (league.sport_id == sportId) {
                            var selected = league.league_id == leagueId ? true : false;
                            return (<option data-id={league.league_id} data-value={league.league_id} key={index} selected={selected}>{league.league_name}</option>);
                          }
                        })}
                      </select>
                    </div>
                    <div className="col-12 mt-4">
                      <select className="create_club_fundraiser_select" id="fundraising_purpose" onChange={handlePurposeChange}>
                        <option value="0">Fundraising Purpose / Beneficiary Group</option>
                        <option value="U14 Team">U14 Team</option>
                        <option value="U16 Team">U16 Team</option>
                        <option value="U21 Team">U21 Team</option>
                        <option value="Senior Team">Senior Team</option>
                        <option value="Girls Academy">Girls Academy</option>
                        <option value="Equipment Fund">Equipment Fund</option>
                        <option value="Club Development Fund">Club Development Fund</option>
                        <option value="General Club Fundraising">General Club Fundraising</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    {showOtherPurpose && (
                      <div className="col-12 mt-4">
                        <input
                          type="text"
                          id="fundraising_purpose_other"
                          className="create_club_fundraiser_select"
                          maxLength="80"
                          placeholder="Enter Fundraising Purpose / Beneficiary Group"
                          value={otherPurposeValue}
                          onChange={(e) => setOtherPurposeValue(e.target.value)}
                        />
                      </div>
                    )}
                    <div className="col-12 mt-4">
                      <input
                        type="number"
                        id="create_club_fundraiser_entry_fee"
                        className="create_club_fundraiser_select"
                        placeholder={!cfLabels.create_club_fundraiser_entryfee ? 'Entry Fee (' + currency + ')' : cfLabels.create_club_fundraiser_entryfee.label_name + ' (' + currency + ')'}
                        data-type="entryfee"
                        step="1"
                        min="1"
                        onChange={(e) => { return setEntryFee(e.target.value); }}
                      />
                    </div>
                    <div className="col-12 mt-4">
                      <input
                        type="number"
                        id="create_club_fundraiser_entrants"
                        className="create_club_fundraiser_select"
                        placeholder={!cfLabels.create_club_fundraiser_entrants ? 'Entrants' : cfLabels.create_club_fundraiser_entrants.label_name}
                        data-type="entrants"
                        step="1"
                        min="2"
                        onChange={(e) => { return setEntrants(e.target.value); }}
                      />
                    </div>
                    <div className="col-12 mt-4">
                      <span className={Number(sportsFirst) + Number(sportsSecond) + Number(sportsThird) + Number(sportsClub) === 100 ? '' : 'red_color'}>
                        {!cfLabels.create_club_fundraiser_payouts ? 'Payouts' : cfLabels.create_club_fundraiser_payouts.label_name} {Number(sportsFirst) + Number(sportsSecond) + Number(sportsThird) + Number(sportsClub)}(%)
                      </span>
                    </div>
                    <div className="col-12 mt-4 club_fundraiser_col fundraiser_currency_col">
                      <span className="light_color">{!cfLabels.create_club_fundraiser_1stplace ? '1st Place' : cfLabels.create_club_fundraiser_1stplace.label_name}</span>
                      <input type="number" maxLength="50" id="create_club_fundraiser_sports_first" className="create_club_fundraiser_select_mini mini_margin_left col-xl-4 col-lg-4" placeholder="50" value={sportsFirst} data-type="sports_first" min="0" max="100" onChange={(e) => { return setSportsFirst(e.target.value); }} />
                      <span className="mini_margin_left club_fundraiser_right"><span className="mini_margin_left club_fundraiser_right">{currencySymbol}{calculateMaxPayout(sportsFirst)}</span></span>
                    </div>
                    <div className="col-12 mt-4 club_fundraiser_col fundraiser_currency_col">
                      <span className="light_color">{!cfLabels.create_club_fundraiser_2ndplace ? '2nd Place' : cfLabels.create_club_fundraiser_2ndplace.label_name}</span>
                      <input type="number" maxLength="50" id="create_club_fundraiser_sports_second" className="create_club_fundraiser_select_mini mini_margin_left col-xl-4 col-lg-4" placeholder="25" value={sportsSecond} data-type="sports_second" min="0" max="100" onChange={(e) => { return setSportsSecond(e.target.value); }} />
                      <span className="mini_margin_left club_fundraiser_right"><span className="mini_margin_left club_fundraiser_right">{currencySymbol}{calculateMaxPayout(sportsSecond)}</span></span>
                    </div>
                    <div className="col-12 mt-4 club_fundraiser_col fundraiser_currency_col">
                      <span className="light_color">{!cfLabels.create_club_fundraiser_3rdplace ? '3rd Place' : cfLabels.create_club_fundraiser_3rdplace.label_name}</span>
                      <input type="number" maxLength="50" id="create_club_fundraiser_sports_third" className="create_club_fundraiser_select_mini mini_margin_left col-xl-4 col-lg-4" placeholder="15" value={sportsThird} data-type="sports_third" min="0" max="100" onChange={(e) => { return setSportsThird(e.target.value); }} />
                      <span className="mini_margin_left club_fundraiser_right"><span className="mini_margin_left club_fundraiser_right">{currencySymbol}{calculateMaxPayout(sportsThird)}</span></span>
                    </div>
                    <div className="col-12 mt-4 club_fundraiser_col">
                      <span className="light_color">{!cfLabels.create_club_fundraiser_club ? 'Club' : cfLabels.create_club_fundraiser_club.label_name}</span>
                      <input type="number" maxLength="50" id="create_club_fundraiser_club" className="create_club_fundraiser_select_mini mini_margin_left col-xl-4 col-lg-4" placeholder="10" value={sportsClub} data-type="sports_club" min="0" max="100" onChange={(e) => { return setSportsClub(e.target.value); }} />
                       <span className="mini_margin_left club_fundraiser_right">
                         <span className="club_fundraiser_amount">{currencySymbol}{calculateMaxPayout(sportsClub)}</span>
                         <span className="club_fundraiser_potential_label">Potential Earnings</span>
                       </span>
                    </div>
                    <div className="row mt-row" style={{display:'none'}}>
                      <div className="col-12 col-xl-6 col-lg-6">
                        <input type="text" id="account_name" className="account_name_input" maxLength="50" placeholder={!cfLabels.create_club_fundraiser_account_name ? 'Account Name' : cfLabels.create_club_fundraiser_account_name.label_name} />
                      </div>
                    </div>
                    <div className="row mt-row" style={{display:'none'}}>
                      <div className="col-12 col-xl-6 col-lg-6">
                        <input type="text" id="sort_code" className="sort_code_input" maxLength="50" placeholder={!cfLabels.create_club_fundraiser_sort_code ? 'Sort Code' : cfLabels.create_club_fundraiser_sort_code.label_name} />
                      </div>
                      <div className="col-12 col-xl-6 col-lg-6">
                        <input type="text" id="account_number" className="account_number_input" maxLength="50" placeholder={!cfLabels.create_club_fundraiser_account_number ? 'Account Number' : cfLabels.create_club_fundraiser_account_number.label_name} />
                      </div>
                    </div>
                    <div className="row mt-row" style={{display:'none'}}>
                      <div className="col-12 col-xl-6 col-lg-6">
                        <select className="currency_select" id="fundraiser_currency" placeholder="Currency" onChange={handleCurrencyChange}>
                          <option value="AUD" selected={currency === 'AUD' ? true : false}>AUD</option>
                          <option value="EUR" selected={currency === 'EUR' ? true : false}>EUR</option>
                          <option value="CAD" selected={currency === 'CAD' ? true : false}>CAD</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-xl-6 col-lg-7 cf_info_column">
                    <div className="cf_accordion cf_accordion_mb">
                      <button className="cf_accordion_header" type="button" onClick={() => setAccordion3Open(!accordion3Open)}>
                        <span>Why Clubs Choose Top Predictor</span>
                        <span className="cf_accordion_icon">{accordion3Open ? '▲' : '▼'}</span>
                      </button>
                      {accordion3Open && (
                        <div className="cf_accordion_content">
                          <ul className="cf_checklist">
                            <li>✓ Weekly and monthly competitions</li>
                            <li>✓ Golf Majors, World Cups, Major Tournaments, and Men's &amp; Women's Tier 1 Leagues</li>
                            <li>✓ No product sales or raffle books</li>
                            <li>✓ Minimal volunteer administration</li>
                            <li>✓ Fund trips, equipment, tours and club initiatives</li>
                            <li>✓ Flexible prize and fundraising allocation.</li>
                            <li>✓ If all entries are not sold, prize and fundraising allocations will be distributed proportionately.</li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="cf_accordion cf_accordion_mb">
                      <button className="cf_accordion_header" type="button" onClick={() => setAccordion4Open(!accordion4Open)}>
                        <span>Example Fundraising Return</span>
                        <span className="cf_accordion_icon">{accordion4Open ? '▲' : '▼'}</span>
                      </button>
                      {accordion4Open && (
                        <div className="cf_accordion_content">
                          <p className="cf_example_label">Example 1</p>
                          <p className="cf_example_row_full">100 Players × {currencySymbol}20 Entry Fee</p>
                          <div className="cf_example_row"><span>Competition Pool:</span><span>{currencySymbol}2,000</span></div>
                          <div className="cf_example_row"><span>Prize Pool (65%):</span><span>{currencySymbol}1,300</span></div>
                          <div className="cf_example_row"><span>Fundraising Allocation (35%):</span><span>{currencySymbol}700</span></div>
                          <div className="cf_example_row cf_example_highlight"><span>Net Club Fundraising Return:</span><span>{currencySymbol}630</span></div>
                          <div className="cf_example_divider"></div>
                          <p className="cf_example_label">Example 2</p>
                          <p className="cf_example_row_full">100 Players × {currencySymbol}20 Entry Fee</p>
                          <div className="cf_example_row"><span>Competition Pool:</span><span>{currencySymbol}2,000</span></div>
                          <div className="cf_example_row"><span>Prize Pool (55%):</span><span>{currencySymbol}1,100</span></div>
                          <div className="cf_example_row"><span>Fundraising Allocation (45%):</span><span>{currencySymbol}900</span></div>
                          <div className="cf_example_row cf_example_highlight"><span>Net Club Fundraising Return:</span><span>{currencySymbol}810</span></div>
                          <p className="cf_example_note">Examples shown for illustration only.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row m-0 mt-4">
                <div className="col-12">
                  <label className="cf_authorise_label">
                    <input
                      type="checkbox"
                      className="cf_authorise_checkbox"
                      checked={authorisedConfirmed}
                      onChange={(e) => setAuthorisedConfirmed(e.target.checked)}
                    />
                    <span>I confirm I am authorised to register this club and provide the club bank details for fundraising payments.</span>
                  </label>
                </div>
              </div>
              <div className="row m-0 mt-4 create_club_fundraiser_btn">
                <div className="col-12">
                  <ButtonPrimary
                    classValue="btn_primary btn_create_club_fundraiser"
                    datapath="my_competition"
                    type="submit"
                    form="form_club_fundraiser"
                    textValue={!cfLabels.create_club_fundraiser_submit ? 'Submit' : cfLabels.create_club_fundraiser_submit.label_name}
                    onClick={getClubFundraiserData}
                  />
                </div>
              </div>
            </form>

            <div className="cf_support_footer">
              <span className="cf_support_text">Need assistance?</span>
              <a href="mailto:clubs@toppredictor.com" className="cf_support_link">clubs@toppredictor.com</a>
            </div>

          </div>
        )}
      </div>
      {loader}
      {alert}
      <Footer />
    </React.Fragment>
  );
}

